import AIPerf2023 from './AIPerf';
import LLM2023 from './AIPerf-LLM';
import InferenceThroughput from './InferenceThroughput';
import InferenceLatency from './InferenceLatency';
import DeepSeek from './deepseek';

export default [
    DeepSeek,
    AIPerf2023,
    LLM2023,
    InferenceThroughput,
    InferenceLatency,
];
